import { Grid, Header, Label, Icon, Button } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { formatDateForView } from "../../utils/dateHelper";

const getLinkStatus = (link) => {
  const now = new Date();
  if (!link.isActive) {
    return { key: "inactive", label: "Inaktiv", color: "grey", icon: "ban" };
  }
  if (link.validFrom && new Date(link.validFrom) > now) {
    return {
      key: "scheduled",
      label: "Geplant",
      color: "blue",
      icon: "clock outline",
    };
  }
  if (link.validUntil && new Date(link.validUntil) < now) {
    return {
      key: "expired",
      label: "Abgelaufen",
      color: "red",
      icon: "calendar times",
    };
  }
  return {
    key: "active",
    label: "Aktiv",
    color: "green",
    icon: "check circle",
  };
};

const LinktreeLinkListItem = ({
  id,
  name,
  url,
  isActive,
  icon,
  openInNewTab,
  validFrom,
  validUntil,
  language,
  createdAt,
  updatedAt,
  onClickDelete,
  onToggleActive,
}) => {
  const { t } = useTranslation();

  const languageLabels = {
    de: "Deutsch",
    en: "Englisch",
  };

  const status = getLinkStatus({
    isActive,
    validFrom,
    validUntil,
  });

  const containerStyle = {
    backgroundColor: "#F0F8FF",
    border: "1px solid #D6E6F5",
    borderLeft: "6px solid #4A90E2",
    borderRadius: "10px",
    padding: "1rem",
    marginBottom: "0.75rem",
    transition: "all 0.15s ease-in-out",
    cursor: "grab",
  };

  return (
    <Grid
      columns="equal"
      stackable
      verticalAlign="middle"
      key={`linktree-link-item-${id}`}
      style={containerStyle}
      className="linktree-link-item"
    >
      {/* NAME + STATUS */}
      <Grid.Column textAlign="left">
        <Header as="h3" style={{ marginBottom: "0.5rem" }}>
          <Icon name={icon || "linkify"} />
          {name}
        </Header>

        <Label size="small" color={status.color}>
          <Icon name={status.icon} />
          {status.label}
        </Label>

        {language && (
          <Label size="small" color="purple">
            <Icon name="language" />
            {languageLabels[language] || language}
          </Label>
        )}

        {openInNewTab === 1 && (
          <Label size="small" color="blue">
            <Icon name="external alternate" />
            {t("label-openInNewTab")}
          </Label>
        )}
      </Grid.Column>

      {/* TARGET URL */}
      <Grid.Column>
        <p style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <Icon name="linkify" color="blue" />
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              maxWidth: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              direction: "rtl",
              textAlign: "left",
            }}
            title={url}
          >
            {url}
          </a>
        </p>
      </Grid.Column>

      <Grid.Column>
        <p>
          {validFrom && (
            <span>
              {t("label-validFrom")} {formatDateForView(validFrom)}
            </span>
          )}
          <br />
          {validUntil && (
            <span>
              {t("label-validUntil")} {formatDateForView(validUntil)}
            </span>
          )}
        </p>
      </Grid.Column>

      <Grid.Column>
        <Button.Group floated="right" vertical>
          <Button negative size="medium" onClick={() => onClickDelete({ id })}>
            <Icon name="trash" />
            {t("button-delete")}
          </Button>

          <Button
            size="medium"
            color={isActive ? "green" : "grey"}
            basic={!isActive}
            onClick={() => onToggleActive({ id, isActive: !isActive })}
            style={{ marginTop: "0.5rem" }}
            title={isActive ? t("hint-deactivate") : t("hint-activate")}
          >
            <Icon name={isActive ? "eye" : "eye slash"} />
            {isActive ? t("button-deactivate") : t("button-activate")}
          </Button>
        </Button.Group>
      </Grid.Column>
    </Grid>
  );
};

export default LinktreeLinkListItem;
